/**
 * Filtre les statuts phase selon la période d'activité (valid_from / valid_until).
 * Les champs de période viennent du meta API ; absents = actif depuis toujours.
 */
export function isStatutActiveInMonth(statut, year, month) {
  if (!statut || statut.active === false) {
    return false;
  }

  const ym = year * 100 + month;
  const fromYm = (statut.valid_from_year ?? 1970) * 100 + (statut.valid_from_month ?? 1);
  if (ym < fromYm) {
    return false;
  }

  if (statut.valid_until_year != null) {
    const untilYm = statut.valid_until_year * 100 + (statut.valid_until_month ?? 12);
    if (ym > untilYm) {
      return false;
    }
  }

  return true;
}

export function isRefActiveInMonth(ref, year, month) {
  return isStatutActiveInMonth(ref, year, month);
}

export function filterRefsForMonth(refs, year, month) {
  return filterStatutsForMonth(refs, year, month);
}

export function filterRefsForContext(refs, year, month) {
  return filterStatutsForContext(refs, year, month);
}

export function filterStatutsForMonth(statuts, year, month) {
  if (!year || !month) {
    return statuts ?? [];
  }
  return (statuts ?? []).filter((s) => isStatutActiveInMonth(s, year, month));
}

/** Statuts actifs sur au moins un mois de l'année (filtre sans mois précis). */
export function filterStatutsForYear(statuts, year) {
  if (!year) {
    return statuts ?? [];
  }
  return (statuts ?? []).filter((s) =>
    Array.from({ length: 12 }, (_, i) => i + 1).some((m) => isStatutActiveInMonth(s, year, m)),
  );
}

export function filterStatutsForContext(statuts, year, month) {
  if (year && month) {
    return filterStatutsForMonth(statuts, year, month);
  }
  if (year) {
    return filterStatutsForYear(statuts, year);
  }
  return statuts ?? [];
}
